export default __webpack_public_path__ + "static/media/ic-antrian.d0a09a4c.svg";